export const version = 'v4.9.2';
